/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { type FunctionComponent, useMemo } from 'react';
import { type Request } from '../../interface/Crash';
import { type Column } from 'react-table';
import { TableContainer } from '../table/TableContainer';
import { Code, Divider } from '@chakra-ui/react';
import { convertObjectToHeaderArray } from './RequestHeaderView';
import { Buffer } from 'buffer';

interface Props {
    request: Request;
}

export const RequestBodyView: FunctionComponent<Props> = (props: Props) => {
    const { request } = props;

    const requestBody = useMemo(() => {
        try {
            if (request.url.startsWith('starfish://graphql') && request.data && typeof request.data === 'string') {
                return JSON.parse(request.data);
            } else if (request.data && 'bytes' in request.data) {
                return Buffer.from(request.data.bytes, 'base64').toString();
            }
        } catch {
            return null;
        }
        return null;
    }, [request.data, request.url]);

    const { tableData, columns } = useMemo(() => {
        if (request.url.startsWith('starfish://graphql') || !requestBody) {
            return { tableData: null, columns: null };
        }

        const requestContentTypeElement = convertObjectToHeaderArray(request.headers).find(
            (item: string[]) => item[0].toLowerCase() === 'content-type',
        );
        const requestContentType = requestContentTypeElement ? requestContentTypeElement[1] : null;
        let interpretedRequestBody: string[][] | null = null;
        if (requestContentType?.includes('urlencoded')) {
            interpretedRequestBody = decodeURIComponent(encodeURIComponent(requestBody))
                .split('&')
                .map((item) => item.split('='));
        } else if (requestContentType?.includes('application/json')) {
            try {
                const _parsedRequestBody = JSON.parse(requestBody);
                interpretedRequestBody = Object.keys(_parsedRequestBody).map((key) => {
                    return [key, _parsedRequestBody[key]];
                });
            } catch (error) {
                console.log('Error during application/json parsing');
                console.log('error: ', error);
                console.log('requestBody: ', requestBody);
            }
        }

        const cols = [
            {
                Header: 'name',
                accessor: (row: string[]) => row[0],
                disableSortBy: true,
            },
            {
                Header: 'value',
                accessor: (row: string[]) => JSON.stringify(row[1], null, 2),
                disableSortBy: true,
            },
        ] as Array<Column<any>>;

        return { tableData: interpretedRequestBody, columns: cols };
    }, [requestBody, request.headers, request.url]);

    return (
        <>
            {request.url.startsWith('starfish://graphql') && requestBody && (
                <Code p={1}>{JSON.stringify(requestBody)}</Code>
            )}
            {!request.url.startsWith('starfish://graphql') && requestBody && <Code p={1}>{requestBody}</Code>}
            {tableData && columns && (
                <>
                    <Divider mt={5} />
                    <TableContainer
                        columns={columns}
                        data={tableData}
                        search={{
                            placeholder: 'Search for values',
                        }}
                    />
                </>
            )}
        </>
    );
};
